import React from "react";
import "./BSUObjectComponent.scss";

import DrawerGoBackComponent from "./DrawerGoBackComponent";
import DrawerRemoveObjectComponent from "./DrawerRemoveObjectComponent";
import { CurrentDrawerOpenType } from "state/slices/RightDrawerSlice";
import BSUPatientHeader from "./BSUPatientHeader";
import { useTypedSelector } from "hooks/store";
import BSUColorItemComponent from "./BSUColorItemComponent";
import { Inventory } from "Classes/InventoryService";
import CMRSliderComponent, { SliderType } from "./CMRSliderComponent";
import { builder } from "Classes/global";

const BSUPortComponent = (): JSX.Element => {
    const modelTitle = useTypedSelector((store) => store.ModelWindow.modelTitle);

    const room = builder?.room;

    if (!room) {
        return null;
    }

    const renderAvailableColors = () => {
        return Object.keys(Inventory.colors).map((key) => {
            if (key === "white" && Object.keys(room.SM_vbsu).length === 0) return undefined;
            if (Inventory.colors[key].isUsed) {
                const color = {
                    name: Inventory.colors[key].name,
                    color: Inventory.colors[key].hexColor,
                };
                return (
                    <BSUColorItemComponent
                        key={color.name}
                        currentColor={color}
                        portSelected={true}
                    />
                );
            }
        });
    };

    return (
        <section className="bsuComponent port">
            <BSUPatientHeader title={modelTitle} />
            <section className="colorPicker">
                <h2>Colour</h2>
                <article className="colorContainer">{renderAvailableColors()}</article>
            </section>
            <CMRSliderComponent type={SliderType.Port} rotate={"X"} title={"Rotate X"} />
            <CMRSliderComponent type={SliderType.Port} rotate={"Y"} title={"Rotate Y"} />
            <DrawerRemoveObjectComponent
                classes={"mt-35 onlyDesktop"}
                type={"port"}
                payload={"port"}
            />
            <DrawerGoBackComponent classes="onlyDesktop" type={CurrentDrawerOpenType.BSUObject} />
        </section>
    );
};

export default BSUPortComponent;
